<template>
    <ValidationObserver ref="validationObserver" slim>
        <div class="forms-feature__form-wrapper">
            <div class="forms-feature__field-block" v-if="!IsClientKnown">
                <div class="forms-feature__field-block-title">{{Strings['Forms.EMobilityServicesSmall.AddressTitle']}}</div>
                <Address :showStreetAndNr="false" :showZipCity="false" :phoneOptional="true" />
            </div>
            <div class="forms-feature__field-block">
                <div class="forms-feature__field-block-title">{{Strings['Forms.EMobilityServicesSmall.PropertyTitleAddress']}}</div>
                <div class="forms-feature__field-row">
                    <ZipCityWithLabel :label="Strings['Global.Address.ZipCity']"
                                      :zipCity="propertyZipCity"
                                      @change="data => updatePropertyZipCity(data.zipcode, data.city, data.countryCode)"
                                      rules="required" />
                </div>
                <div class="forms-feature__field-row">
                    <StreetAutocomplete :label="Strings['Global.Address.Street']"
                                        v-model="propertyStreet"
                                        flex="4"
                                        rules="required" />
                    <InputWithLabel :label="Strings['Global.Address.HouseNr']"
                                    v-model="propertyStreetNumber"
                                    maxlength="10"
                                    flex="1" />
                </div>
                <div class="forms-feature__field-row">
                    <SelectWithLabel v-model="plannedRealizationDate"
                                     :label="Strings['Forms.EMobilityServicesSmall.PlannedRealizationDate']"
                                     rules="required"
                                     :options="realizationDateOptions" />
                </div>
                <div class="forms-feature__field-row">
                    <DatePickerWithLabel :label="Strings['Forms.EMobilityServicesSmall.DateEigentumerversamlung']"
                                         v-model="dateEigentumerversamlung"
                                         cssclass="migrol-form__input-wrapper--medium"
                                         :rules="{ regex: /^((?:19|20)\d{2})-(1[012]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])$/ }" />
                </div>
            </div>
            <div class="forms-feature__field-block forms-feature__field-block--no-separator">
                <div class="forms-feature__field-row">
                    <DSE v-model="dseAccepted" />
                </div>
            </div>

            <ServerErrorMessageList />

            <div class="migrol-form__buttons">
                <AjaxButton :isWaitingForAjax="isWaitingForAjax" :label="Strings['Forms.Submit']" @buttonClick="submitForm" cssclass="migrol-form__button--green" />
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import $ from 'jQuery';
    import Address from '../_common/Address';
    import ServerErrorMessageList from '../_common/ServerErrorMessageList'
    import { ValidationObserver } from 'VeeValidate'
    import { doValidation, getEnumOptions } from '@/utils/utils'

    export default {
        computed: {
            ...mapState([
                'Strings',
                'Enums',
                'IsClientKnown'
            ]),
            ...mapGetters([
                'isWaitingForAjax'
            ]),
            dseAccepted: {
                get() { return this.$store.state.dseAccepted; },
                set(val) { this.$store.commit('setDseAccepted', val); }
            },
            propertyStreet: {
                get() { return this.$store.state.eMobilityServicesSmall.propertyStreet; },
                set(val) { this.$store.commit('eMobilityServicesSmall/setPropertyStreet', val); }
            },
            propertyStreetNumber: {
                get() { return this.$store.state.eMobilityServicesSmall.propertyStreetNumber; },
                set(val) { this.$store.commit('eMobilityServicesSmall/setPropertyStreetNumber', val); }
            },
            propertyZipCity: {
                get() {
                    return {
                        zipcode: this.$store.state.eMobilityServicesSmall.propertyZipcode,
                        city: this.$store.state.eMobilityServicesSmall.propertyCity,
                        countryCode: this.$store.state.eMobilityServicesSmall.propertyCountryCode
                    }
                }
            },
            plannedRealizationDate: {
                get() { return this.$store.state.eMobilityServicesSmall.plannedRealizationDate; },
                set(val) { this.$store.commit('eMobilityServicesSmall/setPlannedRealizationDate', val); }
            },
            dateEigentumerversamlung: {
                get() { return this.$store.state.eMobilityServicesSmall.dateEigentumerversamlung; },
                set(val) { this.$store.commit('eMobilityServicesSmall/setDateEigentumerversamlung', val); }
            },
            realizationDateOptions() {
                return getEnumOptions(this.Enums["RealizationDates"]);
            }
        },
        methods: {
            ...mapActions([
                'TriggerGoal'
            ]),
            submitForm() {
                let formData = { ...this.$store.getters['baseData'], ...this.$store.state.eMobilityServicesSmall };
                var vm = this;
                doValidation(vm.$refs.validationObserver, () => {
                    vm.$store.commit('clearServerErrormessages');
                    vm.$store.commit('increasePendingAjaxCalls');
                    $.post({
                        url: '/migrolapi/' + window.CONFIG.language + '/forms/SubmitEMobilityServicesSmallForm',
                        data: JSON.stringify(formData),
                        contentType: 'application/json'
                    })
                        .done((response) => {
                            if (!response.Success)
                                vm.manageError(response);
                            else {
                                if (window.dataLayer) {
                                    window.dataLayer.push({
                                        event: 'contactform',
                                        formname: 'E-Moblität',
                                        formthema: []
                                    });
                                }
                                this.$router.push('/thanks').catch(() => { });
                                vm.TriggerGoal();
                            }
                        })
                        .fail(() => {
                            vm.manageError(null);
                        })
                        .always(function () {
                            vm.$store.commit('decreasePendingAjaxCalls');
                        });
                });
            },
            manageError(response) {
                if (!response || !response.ErrorMessages || response.ErrorMessages.length == 0)
                    this.$store.commit('addServerErrormessages', [{ TextKey: 'Shop.Errors.GenericError' }]);
                else
                    this.$store.commit('addServerErrormessages', response.ErrorMessages);
            },
            updatePropertyZipCity(zipValue, cityValue, countryCodeValue) {
                this.$store.commit('eMobilityServicesSmall/setPropertyZipAndCity', { zip: zipValue, city: cityValue, countryCode: countryCodeValue });
            }
        },
        components: {
            Address,
            ValidationObserver,
            ServerErrorMessageList
        }
    };
</script>